import { Link } from 'react-router-dom';
import { sportCategories } from '@/mocks/sports';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4">
            体育项目
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            探索热门体育分类
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            涵盖足球、篮球、网球、电竞、赛车、搏击等多元体育项目，满足不同爱好者的需求
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {sportCategories.map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-2xl p-5 border border-background-200/70 hover:border-accent-300 transition-all text-center cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-accent-100 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-400">{cat.articleCount}篇资讯</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}